import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navBar: false,
    loading: false,
    loadingText: "Cargando...",
    sidePanel: true,
    notificationShown: false,
    notificationText: null,
    user: null,
    search: false,
    searchTerm: "",
    searchLabel: "",
    showSearchMobile: false,
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value;
      if (typeof value == "string") {
        state.loadingText = value;
      } else {
        state.loadingText = "Cargando...";
      }
    },
    setNotification(state, value) {
      if (typeof value == "boolean") {
        state.notificationShown = value;

        if (value) {
          setTimeout(() => {
            state.notificationShown = false;
          }, 4000);
        }
      } else {
        state.notificationText = value;
      }
    },
    setNavBar(state, target) {
      state.navBar = target;
    },
    setUser(state, target) {
      state.user = target;
    },
    setSidePanel(state, target) {
      state.sidePanel = target;
    },
    setSearch(state, target) {
      state.search = target;
    },
    setSearchLabel(state, target) {
      state.searchLabel = target;
    },
    setSearchText(state, target) {
      state.searchTerm = target;
    },
    setSearchMobile(state, target) {
      state.showSearchMobile = target;
    },
  },
  actions: {
    showSearch: ({ commit, state }, value) => {
      commit("setSearch", value);
    },
    updateSearchLabel: ({ commit, state }, value) => {
      commit("setSearchLabel", value);
    },
    updateSearchTerm: ({ commit, state }, value) => {
      commit("setSearchText", value);
    },

    showSearchMobileF: ({ commit, state }, value) => {
      commit("setSearchMobile", value);
    },
  },
  modules: {},
});
